//=====================================================================
// Set or remove aria attributes
//=====================================================================
export const setOrRemoveAttributes = (item, AddAttributes = {}, removeAttributes = []) => {
    for (let att in AddAttributes) {
        item.setAttribute(att, AddAttributes[att]);
    }
    removeAttributes.forEach(attributeToRemove => item.removeAttribute(attributeToRemove));
};